import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  IconButton,
  Typography,
  Grid,
  Paper,
  Button
} from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import LoadingButton from '../components/LoadingButton'
import DateInput from '../components/DateInput'
import {
  glTransServerSideCols2,
  glActivityCols,
  moreGlTansCols,
  attribCols
} from '../constants/GlCols'
import getTableOptions from '../constants/TableOptions'
import DialogTable from '../components/DialogTable'
import LoadingCircle from '../components/common/LoadingCircle'
import { smallScreenWidth } from '../constants/AppConstants'
import OpenSearchDropdown from '../components/OpenSearchDropdown'
import HardCodedDropdown from '../components/HardCodedDropdown'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import { DashboardAthenaTable } from '../components/DashboardAthenaTable'
import fetchFromAthena from '../functions/FetchFromAthena'

import GlSystemHeaders from '../components/GlSystemHeaders'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    margin: '2rem 1rem'
  },
  treeRoot: {
    flexGrow: 1,
    margin: '1rem'
  }
}))

const defaultHeaders = {
  fiscalYear: '',
  fromPeriod: '',
  toPeriod: '',
  company: '',
  system: '',
  accountUnit: '',
  account: '',
  subAccount: '',
  includeIntercompany: 1,
  fromDate: '',
  toDate: ''
}

export default function GlTransServerSideV2(props) {
  const [state, setstate] = useState({
    glOptions: null,
    options: null,
    isLoading: false,
    data: null,
    fetched: true,
    isServerSide: false,
    tableKey: JSON.stringify(defaultHeaders)
  })
  const [showTable, setShowTable] = useState(false)
  const [headers, setHeaders] = useState(defaultHeaders)
  const [objInfo, setObjInfo] = React.useState(null)
  const [moreInfo, setMoreInfo] = React.useState(null)
  const [attribInfo, setAttribInfo] = React.useState(null)
  const [clearHeader, setClearHeaders] = React.useState(false)
  const [clearTrigger, setClearTrigger] = React.useState(false)
  const [glHeader, setGlHeader] = React.useState(null)
  const classes = useStyles()

  const { credentials } = props.fetchInitialData

  const handleClose = () => {
    setObjInfo(null)
    setMoreInfo(null)
    setAttribInfo(null)
  }
  const viewAttributes = async objId => {
    const resp = await fetchFromAthena({
      queryName: 'gl_attribute_read',
      headers: {
        objId
      },
      accessToken: credentials.user.accessToken,
      credentials: credentials
    })
    

    setAttribInfo(resp)
  }
  const handleSubmit = e => {
    e.preventDefault()
    if (JSON.stringify(headers) === state.tableKey) return null
    setShowTable(true)
    setstate({ ...state, isLoading: true, tableKey: JSON.stringify(headers) })
  }
  const handleCallback = (values, error) => {
    if (error) {
      setstate({ ...state, isLoading: false })
      setShowTable(false)
      return null
    }
    setstate({ ...state, isLoading: false })
  }

  const tableDataTransformation = rows => {
    return rows.map(row => {
      if (row.ACTIVITY) {
        row['ACTIVITY_LINK'] = (
          <div
            className='editLink'
            onClick={() => {
              const win = window.open(
                `/actrans?id=${row.OBJ_ID}&type=GLT_OBJ_ID`,
                '_blank'
              )
              win.focus()
            }}
          >
            {row.ACTIVITY}
          </div>
        )
      } else {
        row['ACTIVITY_LINK'] = ''
      }
      // let temp = row.ACCOUNT
      // row.ACCOUNT = `${temp}${row.SUB_ACCOUNT ? `-${row.SUB_ACCOUNT}` : ''}`
      row['MORE'] = (
        <div className='editLink' onClick={() => setMoreInfo([row])}>
          view
        </div>
      )
      if (row.HAS_GTMXVALUE) {
        row['GTMXVALUE'] = (
          <div
            className='editLink'
            onClick={() => viewAttributes(row.HAS_GTMXVALUE)}
          >
            view
          </div>
        )
      }

      row['SYSTEM_LINK'] = (
        <div className='editLink' onClick={() => setGlHeader(row)}>
          {row.SYSTEM}
        </div>
      )
      return row
    })
  }

  if (!state.fetched) {
    return <LoadingCircle />
  }

  const options = getTableOptions({
    cols: glTransServerSideCols2,
    fileName: `GL_Trans`
  })
  options.downloadOptions.filterOptions.useDisplayedColumnsOnly = false

  return (
    <div style={{ padding: '1.5rem 0.5rem' }}>
      {glHeader && (
        <GlSystemHeaders
          {...props}
          headers={{
            ...glHeader,
            COMPANY: headers.company,
            FISCAL_YEAR: headers.fiscalYear
          }}
          handleClose={() => setGlHeader(null)}
        />
      )}
      <DialogTable
        isOpen={!!objInfo}
        handleClose={handleClose}
        tableData={objInfo}
        cols={glActivityCols}
        simpleTable={true}
      />
      <DialogTable
        isOpen={!!moreInfo}
        handleClose={handleClose}
        tableData={moreInfo}
        cols={moreGlTansCols}
        simpleTable={true}
      />

      <DialogTable
        isOpen={!!attribInfo}
        handleClose={handleClose}
        tableData={attribInfo}
        cols={attribCols}
        simpleTable={true}
      />
      <IconButton
        style={{ borderRadius: '5px', position: 'absolute' }}
        size='small'
        onClick={() => props.history.push('/')}
        aria-label='delete'
      >
        <ArrowBackIcon />
        {props.fetchInitialData.credentials.appWidth > smallScreenWidth &&
          'Dashboard'}
      </IconButton>
      <Typography variant='h5' style={{ textAlign: 'center' }}>
        GL Trans
      </Typography>
      <div className={classes.root}>
        <Paper elevation={0} style={{ padding: '1rem' }}>
          <form onSubmit={handleSubmit}>
            <Grid
              container
              alignContent='center'
              alignItems='flex-start'
              spacing={3}
            >
              <Grid item>
                <OpenSearchDropdown
                  id='fiscalYear'
                  required
                  width='125px'
                  label='Year'
                  page="GLTRANS"
                  entity="YEAR"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    setHeaders({ ...headers, fiscalYear: val?.VALUE || '' })
                  }}
                />
              </Grid>
              <Grid item>
                <OpenSearchDropdown
                  id='company'
                  required
                  width='125px'
                  label='Company'
                  page="GLTRANS"
                  entity="COMPANY"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    setHeaders({ ...headers, company: val?.VALUE || '' })
                  }}
                />
              </Grid>
              <Grid item>
                <HardCodedDropdown
                  id='fromPeriod'
                  required
                  width='125px'
                  label='Period From'
                  dataset="PERIOD"
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    setHeaders({ ...headers, fromPeriod: val?.VALUE || '' })
                  }}
                />
              </Grid>
              <Grid item>
                <HardCodedDropdown
                  id='toPeriod'
                  required
                  width='125px'
                  label='Period To'
                  dataset="PERIOD"
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    setHeaders({ ...headers, toPeriod: val?.VALUE || '' })
                  }}
                />
              </Grid>
              <Grid item>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={headers.includeIntercompany}
                      onChange={e => {
                        setHeaders({
                          ...headers,
                          includeIntercompany: e.target.checked ? 1 : 0
                        })
                      }}
                      name='includeIntercompany'
                      color='primary'
                    />
                  }
                  label='Include Intercompany'
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignContent='center'
              alignItems='flex-start'
              spacing={3}
            >
              <Grid item>
                <OpenSearchDropdown
                  id='system'
                  required={false}
                  disabled={
                    !(
                      headers.fiscalYear &&
                      headers.fromPeriod &&
                      headers.toPeriod &&
                      headers.company
                    )
                  }
                  width='125px'
                  label='System'
                  page="GLTRANS"
                  entity="SYSTEM"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  filters={{
                    YEAR: headers.fiscalYear,
                    COMPANY: headers.company,
                  }}
                  onChange={(val) => {
                    setHeaders({ ...headers, system: val?.VALUE || '' })
                  }}
                />
              </Grid>
              <Grid item>
                <OpenSearchDropdown
                  id='accountUnit'
                  required={false}
                  disabled={
                    !(
                      headers.fiscalYear &&
                      headers.fromPeriod &&
                      headers.toPeriod &&
                      headers.company
                    )
                  }
                  width='125px'
                  label='Account Unit'
                  page="GLTRANS"
                  entity="ACCTUNIT"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  filters={{
                    YEAR: headers.fiscalYear,
                    COMPANY: headers.company,
                    SYSTEM: headers.system
                  }}
                  onChange={(val) => {
                    setHeaders({ ...headers, accountUnit: val?.VALUE || '' })
                  }}
                />
              </Grid>
              <Grid item>
                <OpenSearchDropdown
                  id='account'
                  required={false}
                  disabled={
                    !(
                      headers.fiscalYear &&
                      headers.fromPeriod &&
                      headers.toPeriod &&
                      headers.company
                    )
                  }
                  width='125px'
                  label='Account'
                  page="GLTRANS"
                  entity="ACCOUNT"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  filters={{
                    YEAR: headers.fiscalYear,
                    COMPANY: headers.company,
                    SYSTEM: headers.system,
                    ACCTUNIT: headers.accountUnit
                  }}
                  onChange={(val) => {
                    setHeaders({ ...headers, account: val?.VALUE || '' })
                  }}
                />
              </Grid>
              <Grid item>
                <OpenSearchDropdown
                  id='subAccount'
                  required={false}
                  disabled={
                    !(
                      headers.fiscalYear &&
                      headers.fromPeriod &&
                      headers.toPeriod &&
                      headers.company
                    )
                  }
                  width='125px'
                  clearTrigger={clearTrigger}
                  label='Sub Account'
                  page="GLTRANS"
                  entity="SUBACCOUNT"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  filters={{
                    YEAR: headers.fiscalYear,
                    COMPANY: headers.company,
                    SYSTEM: headers.system,
                    ACCTUNIT: headers.accountUnit,
                    ACCOUNT: headers.account
                  }}
                  onChange={(val) => {
                    setHeaders({ ...headers, subAccount: val?.VALUE || '' })
                  }}
                />
              </Grid>

              {[
                {
                  id: 'fromDate',
                  label: 'From Date'
                },
                {
                  id: 'toDate',
                  label: 'To Date'
                }
              ].map(field => {
                return (
                  <Grid key={field.id} item>
                    <DateInput
                      id={field.id}
                      key={`${field.id}-${clearHeader}`}
                      type={'date'}
                      required={false}
                      label={field.label}
                      value={headers[field.id]}
                      onChange={e => {
                        setHeaders({
                          ...headers,
                          [field.id]: !!e.target.value ? e.target.value : null
                        })
                      }}
                      variant='standard'
                      width='160px'
                    />
                  </Grid>
                )
              })}
            </Grid>

            <div style={{ marginTop: '1rem' }}>
              <LoadingButton
                label='Submit'
                disabled={!(headers.fiscalYear && headers.acctPeriod)}
                isLoading={state.isLoading}
                color='primaryVLButton'
                buttonType='submit'
              />
              {!!Object.values(headers).some(value => value !== '' && value !== null) && (
                <Button
                  onClick={() => {
                    setClearHeaders(!clearHeader)
                    setHeaders(defaultHeaders)
                    setShowTable(false)
                    setGlHeader(null)
                    setClearTrigger(prev => !prev)
                  }}
                  style={{ marginLeft: '0.5rem' }}
                >
                  Clear
                </Button>
              )}
            </div>
          </form>
        </Paper>

        {showTable && (
          <div style={{ marginTop: '1rem ' }}>

            <DashboardAthenaTable
            {...props}
            isTempTable={true}
            key={state.tableKey}
            params={{ ...headers }}
            tableColumns={glTransServerSideCols2}
            reportParamName="gl_trans_read_serverside_v3"
            reportName='gl_trans_read_serverside_v3_temp'
            tableTitle={''}
            transform={tableDataTransformation}
            callback={handleCallback}
            downloadFileName={'GL_Trans_Download'}
            initialState={{
              columnVisibility: {
                LEVEL_DETAIL_01: false,
                LEVEL_DETAIL_02: false,
                LEVEL_DETAIL_03: false,
                LEVEL_DETAIL_04: false
              }
            }}
            />
            {/* <DashboardAthenaTableServerSideNoSelect
              {...props}
              key={state.tableKey}
              params={{ ...headers }}
              tableColumns={glTransServerSideCols2}
              reportParamName="gl_trans_read_serverside_v3"
              reportName='gl_trans_read_serverside_v3_temp'
              tableTitle={''}
              transform={tableDataTransformation}
              callback={handleCallback}
              downloadFileName={'GL_Trans_Download'}
              initialState={{
                columnVisibility: {
                  LEVEL_DETAIL_01: false,
                  LEVEL_DETAIL_02: false,
                  LEVEL_DETAIL_03: false,
                  LEVEL_DETAIL_04: false
                }
              }}
            /> */}
          </div>
        )}
      </div>
    </div>
  )
}
